const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.25 6A.75.75 0 0 1 5 5.25h14a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 6m0 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 11.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
